import { GlobalStateType, type StateType } from 'Lib/reduxType';
import { omit, pick } from 'Lib/utils/lodashUtils';

export function createKeyInTransform(keys: string[]) {
  return {
    in: (state: GlobalStateType): StateType => pick(state, keys),
  };
}

export function createKeyNotInTransform(keys: string[]) {
  return {
    in: (state: GlobalStateType): StateType => omit(state, keys),
  };
}
